import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FinalFormComponent } from './final-form.component';

const routes: Routes = [
  {
    path: '',
    component: FinalFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinalFormRoutingModule {}
